"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var RectangleChart = /** @class */ (function (_super) {
    __extends(RectangleChart, _super);
    function RectangleChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RectangleChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_leftAxis":
            case "_topAxis":
                return utils_1.parseBoolean(value);
            case "_verticalGap":
            case "_horizontalGap":
                return utils_1.parseNumberWithAuto(value);
            case "_horizontalFunc":
            case "_verticalFunc":
            case "_valueFunc":
            case "_fillFunc":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    RectangleChart.prototype.defaultOptions = function () {
        return {
            _leftAxis: true,
            _topAxis: true,
            _verticalGap: 0,
            _horizontalGap: 0,
            _horizontalFunc: function (d) { return d.y; },
            _verticalFunc: function (d) { return d.x; },
            _valueFunc: function (d) { return d.value; },
            _fillFunc: function (d) {
                var scale = d3.scaleThreshold()
                    .domain([0.85, 1])
                    .range(["#2980B9", "#E67E22", "#27AE60", "#27AE60"]);
                return scale(d.value);
            },
        };
    };
    RectangleChart.prototype.init = function () {
        var _this = this;
        this._toolTip = __1.tooltip.create("recttip");
        this._rects = this.appendGroupT(element_1.Rect).data([]).options({
            _x: function (d) { return _this._horizontalScale(_this._horizontalFunc(d)) + _this._perWidth / 2; },
            _y: function (d) { return _this._verticalScale(_this._verticalFunc(d)) + _this._perHeight / 2; },
            _width: function (_) { return _this._perWidth; },
            _height: function (_) { return _this._perHeight; },
            fill: function (d) { return _this._fillFunc(d); },
            stroke: "white",
        });
    };
    RectangleChart.prototype.postOptionsUpdate = function () {
        this._leftAxis = this.getOption("_leftAxis");
        this._topAxis = this.getOption("_topAxis");
        this._verticalGap = this.getOption("_verticalGap");
        this._horizontalGap = this.getOption("_horizontalGap");
        this._verticalFunc = this.getOption("_verticalFunc");
        this._horizontalFunc = this.getOption("_horizontalFunc");
        this._valueFunc = this.getOption("_valueFunc");
        this._fillFunc = this.getOption("_fillFunc");
    };
    RectangleChart.prototype.prepare = function () {
        var _this = this;
        var horizontalDomain = d3.set(this.datum.map(function (d) { return _this._horizontalFunc(d); })).values();
        var verticalDomain = d3.set(this.datum.map(function (d) { return _this._verticalFunc(d); })).values();
        this._cachedHeight = this._getGeometry("_height", false);
        this._cachedWidth = this._getGeometry("_width", true);
        this._horizontalScale = d3.scaleBand()
            .domain(horizontalDomain)
            .rangeRound([0, this._cachedWidth])
            .paddingInner(this._horizontalGap)
            .paddingOuter(0.001); // Avoid overlap with axis
        this._verticalScale = d3.scaleBand()
            .domain(verticalDomain)
            .rangeRound([0, this._cachedHeight])
            .paddingInner(this._verticalGap)
            .paddingOuter(0.001); // Avoid overlap with axis
        this._perWidth = this._horizontalScale.bandwidth();
        this._perHeight = this._verticalScale.bandwidth();
        this._rects.data(this.datum);
        this.setupProxy({
            horizontalAxis: function (axis) {
                axis.options({
                    _scale: _this._horizontalScale,
                    _gravity: _this._topAxis ? __1.Gravity.Top : __1.Gravity.Bottom,
                    _y: _this._topAxis ? 0 : _this._cachedHeight,
                    _includeStartEndTicks: false,
                });
            },
            verticalAxis: function (axis) {
                axis.options({
                    _scale: _this._verticalScale,
                    _gravity: _this._leftAxis ? __1.Gravity.Left : __1.Gravity.Right,
                    _x: _this._leftAxis ? 0 : _this._cachedWidth,
                    _includeStartEndTicks: false,
                });
            },
        });
    };
    return RectangleChart;
}(_1.Component));
exports.RectangleChart = RectangleChart;
//# sourceMappingURL=rectangle-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/rectangle-chart.js
// module id = 1154
// module chunks = 0 1